export default __webpack_public_path__ + "img/Hinterrhein.0d671fb2.png";